// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","selector":"selector-37fT8","scrollBody":"scrollBody-YaJNr","paper":"paper-1lf-8"};